export default {
methods: {
        
    keyHandler: function(event,type) 
    {
      let key = event.keyCode

      switch(type) 
      {
        case 'Dec' :
            if (
                key == 13 ||
                key == 8 ||
                key == 9 ||
                key == 46 ||
                key == 190 ||
                key == 110 ||
                
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105)
                )
                {
                  return true
                }
                else
                {
                  event.preventDefault()      
                }
        break;

        case 'Num' :
        {
            if(
                key == 8 ||
                key == 9 ||
                key == 46 ||
                key == 13 ||
                
                            
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105)

              )
              {
                return true
              }
            else
              {
                event.preventDefault()      
              }
        }
        break;    

      }

}


}
}